export default __webpack_public_path__ + "static/seznam_logo-e3b457da45b8227323798e0d6bd7fa10.svg";